import React from 'react';
import { useDispatch } from 'react-redux';
import { openPopup } from "../../../../components/Popup/_components/WrapperPopup";
import PopupOpNote from "../../../../components/Popup/PopupOpNote";
import { selectOpDetail, selectPermissions } from '../../../../util/store/selectors';
import { useSelector } from "../../../../util/store/store";
import { IPropsChildren } from "../../../../util/varibles/interface";
import { ACTION } from '../../../../util/varibles/permission';
import { opDetailActions } from "../../reducer";
import stylesContainer from "../../style.module.scss";
import styles from "./style.module.scss";

interface IProps extends IPropsChildren {
    isNote: boolean
}

const Operation: React.FC<IProps> = (props) => {
    const dispatch = useDispatch();
    const data = useSelector(selectOpDetail.data);
    const [canUpdateOperation] = useSelector(selectPermissions([ACTION.OPERATION.UPDATE]));

    const openNode = () => {
        const { operation_code } = data.operation;
        const el = openPopup(<PopupOpNote {...{
            isShow: true,
            info: { code: "#" + operation_code },
            operation: data.operation,
            note: '',
            handleSave: (note: string) => {
                dispatch(opDetailActions.updateOp([{ ...data, operation: { ...data.operation, note } }]))
            },
            handleClose: () => el.remove()
        }} />)
    };

    if (!data.operation) return null;

    return <div className={stylesContainer.section}>
        <div className={stylesContainer['header-box']}>
            <div className='flex align-items-center justify-content-between'>
                <div>Operation info.</div>
                {(props.isNote && canUpdateOperation) && <div className={styles.action} onClick={openNode}>Add note</div>}
            </div>
        </div>
        {props.children}
    </div>;
};

export default Operation;
